import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-bi-price-component-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(PriceComponentMultiSelectSearchControlComponent)
    ]
})
export class PriceComponentMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.bi.search.option.price-component.discount", value: "Discount"},
            {label: "wbo.bi.search.option.price-component.rounding", value: "Rounding"},
            {label: "wbo.bi.search.option.price-component.saleCounts", value: "Sale Counts"},
            {label: "wbo.bi.search.option.price-component.saleLine", value: "Sale Line"},
            {label: "wbo.bi.search.option.price-component.surcharge", value: "Surcharge"}
        ]);
    }
}
